import { render, staticRenderFns } from "./formedModalUpdate.vue?vue&type=template&id=0c638410&scoped=true"
import script from "./formedModalUpdate.vue?vue&type=script&lang=js"
export * from "./formedModalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c638410",
  null
  
)

export default component.exports